import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import {Response} from '@angular/http';
import {Router} from '@angular/router';
import {Observable, Subscription} from 'rxjs/Rx';
import {TranslateService} from 'ng2-translate';
import {AlertService, EventManager, JhiLanguageService} from 'ng-jhipster';
import {Campagne} from './campagne.model';
import {CampagneService} from './campagne.service';
import {ExportService, IKeyedCollection, KeyedCollection, Principal} from '../../shared';
import {ConfirmationService, SelectItem} from 'primeng/components/common/api';
import {Formation, FormationService} from '../formation';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {CampagnePopupService} from './campagne-popup.service';
import {CampagneFormationsDialogComponent} from './campagne-formations-dialog.component';
import {JsUtil} from '../../shared/util/jsUtil';

@Component({
    selector: 'jhi-campagne',
    templateUrl: './campagne.component.html'
})
export class CampagneComponent implements OnInit, AfterViewInit, OnDestroy {
    campagnes: Campagne[];
    selectedCampagnes: Campagne[];
    currentAccount: any;
    eventSubscriber: Subscription;
    now = new Date();
    modalRef: NgbModalRef;

    // Show / Hide selected columns
    cols: SelectItem[] = [
        {label: 'Id', value: 'id'},
        {label: 'Libellés', value: 'libelle'},
        {label: 'Commissions', value: 'commissions'},
        {label: 'Formations', value: 'formations'},
        {label: 'Ouverture', value: 'dateOuverture'},
        {label: 'Fermeture', value: 'dateFermeture'}];
    selectedColumns = ['libelle', 'dateOuverture', 'dateFermeture'];

    // Actions groupées
    actions: SelectItem[] = [
        {label: 'Rattacher des formations', value: 'rattacher'},
        {label: 'Supprimer', value: 'supprimer'}
    ];
    selectedAction = [];
    isLoading: boolean;

    constructor(private jhiLanguageService: JhiLanguageService,
                private campagneService: CampagneService,
                private formationService: FormationService,
                private confirmationService: ConfirmationService,
                private alertService: AlertService,
                private eventManager: EventManager,
                private principal: Principal,
                private router: Router,
                private exportService: ExportService,
                private campagnePopupService: CampagnePopupService,
                private translateService: TranslateService) {
        this.jhiLanguageService.setLocations(['campagne', 'global']);
    }

    loadAll() {
        this.isLoading = true;
        this.campagneService.query().subscribe(
            (res: Response) => {
                this.campagnes = res.json();
                this.isLoading = false;
            },
            (res: Response) => {
                this.onError(res.json());
                this.isLoading = false;
            }
        );
    }

    ngOnInit() {
        this.loadAll();
        this.principal.identity().then((account) => {
            this.currentAccount = account;
        });
        this.registerChangeInCampagnes();
    }

    ngAfterViewInit(): void {
        const translateKey = 'cadensApp.campagne.colonnes';
        const multiSelectId = 'columnSelection';
        this.translateService.get(translateKey).subscribe(translation => {
            JsUtil.setMultiSelectLabel(multiSelectId, translation);
        });
    }

    goToCampagne(campagne: Campagne) {
        this.router.navigate(['/campagne/' + campagne.id]);
    }

    onSelectedAction(event) {
        if (this.selectedCampagnes != null && this.selectedCampagnes.length > 0) {
            // Rattacher des formations aux campagnes sélectionnées
            if (this.selectedAction.indexOf('rattacher') > -1) {
                this.modalRef = this.campagnePopupService.open(CampagneFormationsDialogComponent,
                    this.selectedCampagnes.map(c => new Campagne(c.id)));
            } else if (this.selectedAction.indexOf('supprimer') > -1) {
                // Supprimer des campagnes sélectionnées
                this.delete();
            }
        } else {
            this.selectedAction = [];
        }
    }

    cancel() {
        this.selectedAction = [];
        this.selectedCampagnes = [];
    }

    delete() {
        this.confirmationService.confirm({
            message: this.translateService.instant('cadensApp.campagne.delete.question', {param: this.selectedCampagnes.length}),
            header: this.translateService.instant('cadensApp.campagne.delete.title'),
            accept: () => {
                let updates = [];
                this.selectedCampagnes.forEach(campagne => {
                    updates.push(this.campagneService.delete(campagne.id));
                });
                Observable.forkJoin(updates).subscribe((results: any[]) => {
                    this.selectedAction = [];
                    this.selectedCampagnes = [];
                    this.loadAll();
                }, error => {
                    this.onError(error);
                    this.selectedAction = [];
                });
            },
            reject: () => {
                this.selectedAction = [];
            }
        });
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.eventSubscriber);
    }

    registerChangeInCampagnes() {
        this.eventSubscriber = this.eventManager.subscribe('campagneListModification', (response) => this.loadAll());
    }

    exportFormationsCSV() {
        this.formationService.query({userId: this.currentAccount.id}).subscribe(
            (res: Response) => {
                let formations = res.json();
                let formationPourChaqueCampagne: any[] = [];
                formations.forEach(formation => {
                    formation.campagnes.forEach(campagne => {
                        formationPourChaqueCampagne.push(
                            { nomCampagne: campagne.libelle  , nomFormation: formation.libelle } );
                    });
                });
                let colFieldNameDictionary: IKeyedCollection<String> = new KeyedCollection<String>();
                colFieldNameDictionary.Add('Formation', 'nomFormation');
                colFieldNameDictionary.Add('Campagne', 'nomCampagne');

                this.exportService.toCSVAvecNomOrigineField(formationPourChaqueCampagne, ['Formation', 'Campagne'], colFieldNameDictionary, null, 'CampagnesFormations.csv');
            },
            (res: Response) => this.onError(res.json())
        );
    }

    exportCSV() {

        let colHeaderDictionary: IKeyedCollection<String> = new KeyedCollection<String>();
        this.cols.forEach(col => {
            colHeaderDictionary.Add(col.value, col.label);
        });

        this.exportService.toCSVAvecNomOrigineField(this.campagnes, this.selectedColumns, null, colHeaderDictionary, 'Candidatures.csv');

    }


    private onError(error) {
        this.alertService.error(error.message, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/campagne/campagne.component.ts